import { cn } from '@/lib/utils'

import type { SituacaoFinanceira } from '../domain/financeiro'
import { rotuloDaSituacao } from '../utils/situacao-financeira'

// O texto sempre está presente; a cor só reforça (não depende dela).
const COR: Record<SituacaoFinanceira, string> = {
  SEM_COBRANCA: 'bg-zinc-300/40',
  EM_DIA: 'bg-lime-400/40',
  ATRASADA: 'bg-red-400/40',
  PAGA: 'bg-blue-400/40',
}

export function SituacaoFinanceiraBadge({
  situacao,
}: {
  situacao?: SituacaoFinanceira | null
}) {
  if (!situacao) return null

  return (
    <div
      data-situacao={situacao}
      className={cn(
        'w-[120px] overflow-hidden text-ellipsis whitespace-nowrap rounded-md text-center text-xs font-bold shadow-sm',
        COR[situacao],
      )}
    >
      {rotuloDaSituacao(situacao)}
    </div>
  )
}
